import { Controller } from "stimulus";

export default class extends Controller {

  static targets = ["submitBtn"];

  connect() {

  }

  submitForm() {
    this.submitBtnTarget.click();
  }

}